module.exports = __webpack_public_path__ + "media/images/gallery/uv-b3a5c092896d6e6dc0e1d101ddfc9a94.png";